export const replaceUndefinedCoord = (coord) => {
    if (Array.isArray(coord)) {
        return coord.map(replaceUndefinedCoord);
    }
    if (coord) {
        return coord;
    }
    return 0;
};
//# sourceMappingURL=replaceUndefinedCoord.js.map